import { render, staticRenderFns } from "./UploadTable.vue?vue&type=template&id=0248bfc7"
import script from "./UploadTable.vue?vue&type=script&lang=js"
export * from "./UploadTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports